import React, { useEffect, useState } from "react";
import { FakeGuards } from "../../../fakeStorage/guardrails/Guarddrails";
import { IGuardrail } from "../../../models/Guardrail.model";
import { IForm } from "../../shared/widgets/Form/models/Form.model";
import { GuardrailsForm } from "./GuardrailsForm";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import SharedForm from "../../shared/widgets/Form/Form";
import CardLayout from "../../shared/pageLayouts/cardLayout/CardLayout";
import Card from "../../shared/widgets/Card/Card";
import { APIService } from "../../../services/APIService";
import { ServiceURI } from "../../../services/ServiceURI";
import CreateLayout from "../../shared/pageLayouts/createLayout/CreateLayout";
import { InputTextarea } from "primereact/inputtextarea";
import "./Guardrails.scss";
import { SiAdguard } from "react-icons/si";

interface IPatternForm {
  name: string;
  descripiton: string;
  patterns: IForm[];
}

const patternForm = {
  name: "",
  descripiton: "",
  patterns: GuardrailsForm,
};

export default function GuardrailsPage() {
  const [isCreateTab, setIsCreateTab] = useState(false);
  const [guardrails, setGuardrails] = useState<IGuardrail[]>(FakeGuards);
  const [form, setForm] = useState<IPatternForm>(patternForm);
  const [isEditMode, setIsEditMode] = useState(false);

  const handleSaveForm = () => {};

  const handleAddPattern = () => {
    setForm({ ...form, patterns: form.patterns.concat(GuardrailsForm) });
  };

  const fetchGuardrails = async () => {
    const res = await APIService.getCall(
      ServiceURI.GUARDRAILS.FATCH_GUARDRAILS
    );
    if (res) {
      setGuardrails(res);
    }
  };

  const handleCardClick = (index: number) => {
    const selectedCard: any = guardrails.find((_, i) => i === index) || null;
    if (selectedCard) {
      const newPatternForm: IForm[] = [];

      selectedCard.patterns.forEach((cardItem: any) => {
        GuardrailsForm.forEach((item) => {
          newPatternForm.push({ ...item, value: cardItem[item.field] });
        });
      });

      setIsEditMode(true);
      setForm({
        name: selectedCard.name,
        descripiton: selectedCard.description,
        patterns: newPatternForm,
      });
      setIsCreateTab(true);
    }
  };

  useEffect(() => {
    fetchGuardrails();
  }, []);

  return (
    <div className="guardrails-layout">
      {isCreateTab ? (
        <CreateLayout
          title="Guardrail"
          contentChildren={GuardrailsContent(
            setIsCreateTab,
            form,
            setForm,
            handleAddPattern,
            handleSaveForm,
            isEditMode
          )}
          goBack={() => setIsCreateTab(false)}
        />
      ) : (
        <CardLayout
          title="Guardrail"
          addButtonClicked={() => {
            setIsEditMode(false);
            setForm(patternForm);
            setIsCreateTab(true);
          }}
        >
          {guardrails.map((item, i) => {
            return (
              <Card
                key={i}
                icon={<SiAdguard />}
                item={{
                  title: item.name,
                  content: item.description,
                  logo: item.logo,
                }}
                handleCardClick={() => handleCardClick(i)}
              />
            );
          })}
        </CardLayout>
      )}
    </div>
  );
}

const GuardrailsContent = (
  setIsCreateTab: any,
  form: IPatternForm,
  setForm: any,
  handleAddPattern: any,
  handleSaveForm: any,
  isEditMode: boolean
) => {
  const formRender = (
    <div className="create-form-content">
      <div className="quard-form">
        <div className="form-group">
          <label>Name</label>
          <InputText
            value={form.name}
            placeholder="Enter Name"
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />
        </div>

        <div className="form-group">
          <label>Description</label>
          <InputTextarea
            value={form.descripiton}
            placeholder="Enter Description"
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            rows={5}
            cols={30}
          />
        </div>

        <div className="add-pattern">
          <Button label="+ Add" onClick={() => handleAddPattern()} />
        </div>

        <SharedForm
          form={form.patterns}
          setForm={(patternValue: IForm[]) =>
            setForm({ ...form, patterns: patternValue })
          }
        />
      </div>
    </div>
  );

  const footerRender = (
    <div className="create-form-footer">
      <Button
        label="Cancel"
        severity="secondary"
        outlined
        onClick={() => setIsCreateTab(false)}
      />
      <Button
        label={`${isEditMode ? "Update" : "Create"} Guardrail`}
        onClick={() => handleSaveForm()}
      />
    </div>
  );

  return (
    <>
      {formRender}
      {footerRender}
    </>
  );
};
